import type { SVGProps } from 'react';
const SvgHealth = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 11" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.152 1.796a2.9 2.9 0 0 0-.94-.59 3.06 3.06 0 0 0-2.215 0c-.351.137-.67.337-.94.59l-.557.523-.558-.523A3 3 0 0 0 3.895 1c-.768 0-1.504.286-2.047.796-.543.509-.848 1.2-.848 1.92s.305 1.41.848 1.92l.558.523L6.5 10l4.094-3.84.558-.524c.269-.252.482-.551.628-.88a2.57 2.57 0 0 0 0-2.08 2.7 2.7 0 0 0-.628-.88"
    />
  </svg>
);
export default SvgHealth;
